function filterElementAndChildren(view, selector) {
	let allElements = view.$('*')

	return allElements.filter((i, element) => {
		let isElementOrChild = view.$(element).closest(selector).length > 0
		return !isElementOrChild
	})
}

export default {
	filterElementAndChildren: filterElementAndChildren
}